<template>
  <div class="simple-btn">
    <a
      :style="{ backgroundColor: content.backgroundColor ? content.backgroundColor.color : '#000', color: content.color ? content.color.color : '#fff'}"
      @click.prevent="getStoryblokLink(content.link, content.blank)"
      :href="content.link.cached_url"
    >
      <fai :icon="getIcon(content.icon)" class="icon"></fai>
      <p>{{content.text}}</p>
    </a>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
export default {
  mixins: [storyblokLink],
  props: {
    content: null,
  },
  methods: {
    getTarget() {
      return this.tab ? "_blank" : "_self";
    },
    getIcon(icon) {
      if (icon) {
        return icon.icon.replace("fa-", "");
      }
    },
  },
};
</script>

<style lang="scss">
.simple-btn {
  > a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    padding:15px 50px;
    border-radius:5px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    p {
        font-size:23px;
    }
    .icon {
        font-size:45px;
        margin-bottom:10px;
    }
  }
}
</style>